// extracted by mini-css-extract-plugin
export default {"stickySave":"StorageRetention_stickySave__+IDIr","errorCell":"StorageRetention_errorCell__zcd+f","chartCard":"StorageRetention_chartCard__EelUT"};